import { Expose, Transform, Type } from 'class-transformer';
import { ClubEntity } from './club.entity';

export class Credentials {
  id: string;
  username: string;
  userId: number;
  firstName?: string;
  email?: string;
  lastName?: string;

  @Expose({ name: 'phone_nr' })
  phoneNo?: string;

  permissions?: (string | undefined)[];

  @Expose({ name: 'access_token' })
  token: string;

  @Expose({ name: 'expires_in' })
  expiresIn: number;

  @Expose({ name: 'refresh_token' })
  refreshToken: string;

  @Expose({ name: 'refresh_expires_in' })
  refreshExpiresIn: number;

  @Expose({ name: 'database_id' })
  databaseId: string;

  @Expose({ name: 'team_id' })
  teamId: string;

  @Expose({ name: 'member_id' })
  memberId: number;

  @Expose({ name: 'Club' })
  @Type(() => ClubEntity)
  club: ClubEntity;

  isEditor: boolean;
  isSecretary: boolean;
  isMember: boolean;

  @Expose({ name: 'isMember_light' })
  isMemberLight: boolean;

  @Expose({ name: 'isMember_light_admin' })
  isMemberLightAdmin: boolean;

  isFunctionary: boolean;
  roles: string[];
  isAdmin: boolean;
  guestUser: boolean;
  mobileThemeColour: string;

  @Expose({ name: 'coursePermisssion' })
  @Type(() => CoursesPermission)
  coursePermission: CoursesPermission[];

  @Expose({ name: 'allowAdvertis' })
  allowAdvertisement: number;

  @Expose()
  headlineOption = 0;

  @Expose({ name: 'qrcode_url' })
  qrcodeUrl: string;

  @Expose()
  customerTheme: any[];

  @Expose({ name: 'last_active_date' })
  lastActiveDate: string;

  @Expose({ name: 'deleted_user' })
  @Transform(({ value }) => Number(value) === 1, { toClassOnly: true })
  deletedUser: boolean;

  get fullName() {
    return this.firstName + ' ' + this.lastName;
  }
}

class CoursesPermission {
  @Expose({ name: 'vcloud_isCourse' })
  vCloudCourseAccess: 0 | 1 = 0;

  @Expose({ name: 'vcloud_isShiftPlanning' })
  vCloudWorkShiftsAccess: 0 | 1 = 0;
}
